/** @format */

// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../../../../types/typings.d.ts" />

import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { LocalStorageConfig } from '@shared/data-access/interfaces';
import { WINDOW_PROVIDERS } from './window.service';
import { Store } from '../app.store';

@NgModule({ imports: [], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class WindowModule {
  static forRoot(
    localStorageConfig: LocalStorageConfig | undefined,
  ): ModuleWithProviders<WindowModule> {
    return {
      ngModule: WindowModule,
      providers: [
        { provide: LocalStorageConfig, useValue: localStorageConfig || undefined },
        WINDOW_PROVIDERS,
        Store,
      ],
    };
  }
}
